import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { AuthProvider } from './lib/auth';
import './lib/gsap'; // register plugins once
import './styles.css';

const root = document.getElementById('root');
if (root === null) throw new Error('Root element not found');

// StrictMode intentionally omitted — its dev-time double-mount conflicts with
// GSAP's tween/ScrollTrigger lifecycle (kills mid-flight, leaves elements
// stuck at opacity 0). Production behavior is unaffected. Re-enable when
// migrating to @gsap/react's useGSAP hook on every component.
createRoot(root).render(
  <BrowserRouter>
    <AuthProvider>
      <App />
    </AuthProvider>
  </BrowserRouter>,
);
